import { useIntl } from '@/intl'
import { useSelectFilter } from '@/scopes/search/search/domain/hooks'
import { getFilterAISelection } from '@/scopes/search/search/infrastructure/store/selectors'
import { useSearchStoreSelector } from '@/scopes/search/search/infrastructure/store/useSearchStore'
import { TokenWrapper } from '@/scopes/search/search/pages/SearchPage/components/SelectedFiltersTokens/index'
import { useCallback } from 'react'

function DistanceToCenterTokens() {
  const intl = useIntl()
  const { isFetching, isLoading, selectedOption, selectedValue, setSelection } = useSelectFilter('MetersToCenter')
  const aiSelectedValue = useSearchStoreSelector(getFilterAISelection, 'MetersToCenter') as string

  const handleRemoveClick = useCallback(() => {
    setSelection(null)
  }, [setSelection])

  if (isLoading)
    return null
  if (!selectedOption)
    return null

  return (
    <TokenWrapper value={selectedValue} disabled={isFetching} dismissible onDismissClick={handleRemoveClick} icon={aiSelectedValue === selectedValue ? 'Ai' : undefined}>
      {selectedOption.value === '0'
        ? selectedOption.name
        : intl.formatMessage({ id: 'filter_chips_distance_to_centre' }, { distance: selectedOption.name })}
    </TokenWrapper>
  )
}

function DistanceToBeachTokens() {
  const intl = useIntl()
  const { isFetching, isLoading, selectedOption, selectedValue, setSelection } = useSelectFilter('MetersToBeach')
  const aiSelectedValue = useSearchStoreSelector(getFilterAISelection, 'MetersToBeach') as string

  const handleRemoveClick = useCallback(() => {
    setSelection(null)
  }, [setSelection])

  if (isLoading)
    return null
  if (!selectedOption)
    return null

  return (
    <TokenWrapper value={selectedValue} disabled={isFetching} dismissible onDismissClick={handleRemoveClick} icon={aiSelectedValue === selectedValue ? 'Ai' : undefined}>
      {selectedOption.value === '0'
        ? selectedOption.name
        : intl.formatMessage({ id: 'filter_chips_distance_to_beach' }, { distance: selectedOption.name })}
    </TokenWrapper>
  )
}

export function DistanceToInterestTokens() {
  return (
    <>
      <DistanceToCenterTokens />
      <DistanceToBeachTokens />
    </>
  )
}
